
export enum TagType {
  LOT = '1',          //批次码
  LOCATION = '2',     //库位码
  REQ = '3',          //需求清单码
  PURCHASE = '4',     //采购码
  SALE = '5',         //销售码
  IN_BOUND = '6',     //入库码
  OUT_BOUND = '7',    //出库码
  ORIGIN = '8',       //未知码、物料条码【取源字符】
  LOTINFO = '9',      //批次码右边【供应商编码、采购单号、需求清单号】
  PRODUCT = 'A',      //料号
  INSPECTION = 'B',      //巡检单
}

export interface CodeDataObj {
  p: string; //productCode 存货编码
  l: string; //lot 批次号
  t: string; //thdLot 三方批次号
  c: string; //count 数量
  u: string; //uom 主计量单位
  po: string; //采购单号
  r: string; //ro 需求单号
  s: string; //so 供应商编码
  ln: string; //locNo 库位编码
  i: string; //inventory 出入库
  in: string; //inspection 巡检单
  o: string; //origin 原码未知
  tt: TagType
}

export interface ParseCode extends CodeDataObj {
  originStr: string;
}

export const codeObjToStr = (data: Partial<CodeDataObj>) => {
  let res = '';
  try {
    // 过滤掉空字符串的字段，保持res字符串简短
    const filteredData = Object.fromEntries(
      Object.entries(data).filter(([_, value]) => !!value)
    );
    res = JSON.stringify(filteredData);
  } catch {
    res = '';
  }
  return res;
};

export const isSerializable = (str: string) => {
  if (typeof str !== 'string') return false;

  try {
    JSON.parse(str);
    return true;
  } catch (e) {
    return false;
  }
}

export const strToCodeObj = (str: string): ParseCode => {
  let res: CodeDataObj = {
    p: '',
    l: '',
    t: '',
    c: '',
    u: '',
    po: '',
    r: '',
    s: '',
    ln: '',
    i: '',
    in: '',
    o: '',
    tt: TagType.ORIGIN
  };
  try {
    res = { ...JSON.parse(str) };
  } catch {
    res.tt = TagType.ORIGIN;
    res.o = str;
    console.log('strToCodeObj>>>>ERR:', str);
  }
  return {
    ...res,
    originStr: str,
  };
};

export const over30Text = (str: string | undefined | null) => {
  if (!!!str) return '';
  else {
    if (str.length > 22) return str.slice(0, 22) + '...'
    else return str;
  }
};

export const getParseCode = (key: keyof CodeDataObj, str: string) => {
  let codeObj = strToCodeObj(str);
  return codeObj[key] || codeObj["originStr"];
}

export const strToTime: (str: string) => number = (str) => {
  if (!str || str.length !== 8 || !(/^\d{8}$/.test(str))) {
    return 0;
  }
  const date = new Date(`${str.substring(0, 4)}-${str.substring(4, 6)}-${str.substring(6, 8)}`);
  return date.getDate();
};

export enum LotEnum {
  WMS = "WMS",
  WMSLOTV2 = "WMSLOTV2",
  MES_31 = "MES_31",
  MES_33 = "MES_33",
  MES_41 = "MES_41",
  TL = "TL",
  CW_1 = "CW_1",
  CW_2 = "CW_2",
}

export interface MesLot {
  productCode: string;
  supplierCode: string;
  quantity: number;
  index: string;
  productionCycle: string;
  arrivalAt?: number;
  typeStr: LotEnum;
}
export interface WmsLot {
  productCode: string;
  quantity: number;
  typeStr: LotEnum;
}

export interface TLLot {
  productCode: string;
  supplierCode: string;
  quantity: number;
  productionCycle: string;
  typeStr: LotEnum;
}

export interface CWLot {
  productCode: string;
  quantity: number;
  supplierCode: string;
  orderNumber: string;
  productionCycle: string;
  typeStr: LotEnum;
}

export interface WMSLotV2 {
  productCode: string;
  supplierCode: string;
  uomQty: string;
  uomSeq: string;
  productDate: string;
  typeStr: LotEnum;
}

export const getSpliter = (str: string) => {
  const candidates = ['!', '@', '#', '$', '%', '.', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
  // const candidates = ['!', '@', '#'];
  for (const ch of candidates) {
    if (!str.includes(ch)) {
      return ch;      // 返回第一个不在字符串中的候选字符
    }
  }
  return '';
}

export const generateLotV2 = (productCode: string, supplierCode: string, now: number) => {
  let allStr: string = `${productCode}${supplierCode}${''}${''}${now}`;
  const spliter = getSpliter(allStr);
  if (!!!spliter) return ''
  return `${spliter}/${productCode}${spliter}/${supplierCode}${spliter}/${''}${spliter}/${''}${spliter}/${now}`;
}

export const wmslotV2Parse = (lot: string): { lotData: WMSLotV2, lotStr: string } => {
  if (lot[1] === '/') {
    const spliter = lot[0];
    let resList = lot.split(`${spliter}/`);
    return {
      lotData: {
        productCode: resList[0] ?? '',
        supplierCode: resList[1] ?? '',
        uomQty: resList[2] ?? '',
        uomSeq: resList[3] ?? '',
        productDate: resList[4] ?? '',
        typeStr: LotEnum.WMSLOTV2,
      },
      lotStr: resList.join('')
    }
  } else return {
    lotData: {
      productCode: '',
      supplierCode: '',
      uomQty: '',
      uomSeq: '',
      productDate: '',
      typeStr: LotEnum.WMSLOTV2,
    },
    lotStr: lot
  }
}

export const lotStrParseMES = (mesLot: string): MesLot | null => {
  let mesLotLength_0 = 9 + 6 + 7 + 5 + 4;   //31
  let mesLotLength_1 = 9 + 6 + 7 + 5 + 6;   //33
  let mesLotLength_2 = 9 + 6 + 7 + 5 + 6 + 8; //41
  let type: LotEnum | null = null;
  if (mesLot.length === mesLotLength_0) type = LotEnum.MES_31
  if (mesLot.length === mesLotLength_1) type = LotEnum.MES_33
  if (mesLot.length === mesLotLength_2) type = LotEnum.MES_41
  if (!!!type) return null;
  else {
    // 解析 MES 批次码格式: productCode(9) + supplierCode(6) + quantity(7) + index(5) + productionCycle(6)
    const productCode = mesLot.substring(0, 9);
    const supplierCode = mesLot.substring(9, 15);
    const quantityStr = mesLot.substring(15, 22);
    const index = mesLot.substring(22, 27);
    const productionCycle = mesLot.substring(27, 33);
    const arrivalAtStr = mesLot.substring(33, 41);
    const quantity = parseInt(quantityStr, 10);

    return {
      productCode,
      supplierCode,
      quantity,
      index,
      productionCycle,
      arrivalAt: arrivalAtStr ? strToTime(arrivalAtStr) : undefined,
      typeStr: type
    };
  }
}
export const lotStrParseTL = (tlLot: string): TLLot | null => {
  const SPLITOR = "_&_";
  if (!tlLot.includes(SPLITOR)) return null;
  const parts = tlLot.split(SPLITOR);

  // 解析各字段，能取到几个就是几个，取不到就是空字符串或0
  const productCode = parts[0] || '';
  const supplierCode = parts[1] || '';
  const quantityStr = parts[2] || '';
  const productionCycle = parts[7] || '';

  // 解析数量，如果不是有效数字则返回0
  const quantity = parseInt(quantityStr, 10);

  return {
    productCode,
    supplierCode,
    quantity: isNaN(quantity) ? 0 : quantity,
    productionCycle,
    typeStr: LotEnum.TL
  };
}
export const lotStrParseCW_1 = (cwLot: string): CWLot | null => {
  const SPLITOR = ":";
  if (!cwLot.includes(SPLITOR)) return null;
  if (cwLot.includes('{') && cwLot.includes('}') && cwLot.includes(',') && cwLot.includes(SPLITOR)) return null;//可序列化，是我们的条码
  const parts = cwLot.split(SPLITOR);

  // 解析各字段，能取到几个就是几个，取不到就是空字符串或0
  const productCode = parts[1] || '';
  const quantityStr = parts[3] || '';
  const supplierCode = parts[4] || '';
  const orderNumber = parts[6] || '';
  const productionCycle = parts[7] || '';

  // 解析数量，如果不是有效数字则返回0
  const quantity = parseInt(quantityStr, 10);

  return {
    productCode,
    quantity: isNaN(quantity) ? 0 : quantity,
    supplierCode,
    orderNumber,
    productionCycle,
    typeStr: LotEnum.CW_1
  };
}
export const lotStrParseCW_2 = (cwLot: string): CWLot | null => {
  const SPLITOR = ":";
  if (!cwLot.includes(SPLITOR)) return null;
  if (cwLot.includes('{') && cwLot.includes('}') && cwLot.includes(',') && cwLot.includes(SPLITOR)) return null;//可序列化，是我们的条码
  const parts = cwLot.split(SPLITOR);

  // 解析各字段，能取到几个就是几个，取不到就是空字符串或0
  const productCode = parts[1] || '';
  const quantityStr = parts[3] || '';
  const supplierCode = parts[2] || '';
  const orderNumber = parts[18] || '';
  const productionCycle = parts[14] || '';

  // 解析数量，如果不是有效数字则返回0
  const quantity = parseInt(quantityStr, 10);

  return {
    productCode,
    quantity: isNaN(quantity) ? 0 : quantity,
    supplierCode,
    orderNumber,
    productionCycle,
    typeStr: LotEnum.CW_2
  };
}
export type LotResBase = { typeStr: LotEnum; originLot: string } & Record<string, any>

export const allParseLotRes = (lot: string) => {
  let resList: Array<LotResBase> = [];

  let wmsRes = strToCodeObj(lot);

  if (wmsRes.p) {
    resList.push({
      productCode: wmsRes.p,
      quantity: wmsRes.c,
      typeStr: LotEnum.WMS,
      originLot: wmsRes.l || '',
    })
  }
  if (lot[1] === '/') {
    let pasrRes = wmslotV2Parse(lot);
    resList.push({
      ...pasrRes.lotData,
      originLot: lot
    })
  }

  let mesRes = lotStrParseMES(lot);
  if (mesRes) resList.push({
    ...mesRes,
    originLot: lot,
  });

  let tlRes = lotStrParseTL(lot);
  if (tlRes) resList.push({
    ...tlRes,
    originLot: lot
  });

  let cw1Res = lotStrParseCW_1(lot);
  if (cw1Res) resList.push({
    ...cw1Res,
    originLot: lot
  });

  let cw2Res = lotStrParseCW_2(lot);
  if (cw2Res) resList.push({
    ...cw2Res,
    originLot: lot
  });
  return resList;
}